import { useIntl } from '@/intl'
import { FilterableCarsAvailable } from '@/scopes/checkout/components/services/CarRentalFilteringService/FilterableCars/FilterableCarsAvailable'
import { useCarRentalServiceStore } from '@/scopes/checkout/components/services/CarRentalFilteringService/store'
import { useService } from '@/scopes/checkout/domain/hooks'
import { Sheet } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { ServiceType } from '../../../domain/types'

export function UpgradeCarsListView({ open }: { open: boolean }) {
  const { service } = useService(ServiceType.CarRentalFiltering)
  const intl = useIntl()

  const { setCarIsBeingUpgraded } = useCarRentalServiceStore()
  if (!service)
    return null

  return (
    <Sheet.Root
      open={open}
      onOpenChange={(open) => {
        setCarIsBeingUpgraded(open)
      }}

    >
      <Sheet.Body side="bottom" hasPadding={false}>
        <Sheet.Header titleLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_title' })} closeLabel={intl.formatMessage({ id: 'checkout_steps_ancillaries_car_rental_filtering_all_cars_close_text' })} />
        <FilterableCarsAvailable />
      </Sheet.Body>
    </Sheet.Root>
  )
}
